import { EventTemplateFilter, EventTemplate, EventTemplateWM } from './event-template.types';
import { PagedList } from '../../common/common.types';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as qs from 'qs';

@Injectable()
export class EventTemplateService {
	private readonly templateUrl = 'api/eventTemplates';

	constructor(private http: HttpClient) { }

	getTemplates(templateFilter?: EventTemplateFilter): Promise<PagedList<EventTemplate>> {
		const params = new HttpParams({
			fromString: qs.stringify(templateFilter, { allowDots: true, skipNulls: true })
		});

		return this.http.get<PagedList<EventTemplate>>(this.templateUrl, { params: params })
			.toPromise();
	}

	getTemplate(templateId: number): Promise<EventTemplate> {
		return this.http.get<EventTemplate>(`${this.templateUrl}/${templateId}`)
			.toPromise();
	}

	createTemplate(newTemplate: EventTemplateWM): Promise<number> {
		return this.http.post<number>(this.templateUrl, newTemplate)
			.toPromise();
	}

	updateTemplate(templateId: number, updatedTemplate: EventTemplateWM): Promise<void> {
		return this.http.put<void>(`${this.templateUrl}/${templateId}`, updatedTemplate)
			.toPromise();
	}

	activateTemplate(templateId: number): Promise<void> {
		return this.http.put<void>(`${this.templateUrl}/${templateId}/Status/Active`, null)
			.toPromise();
	}

	archiveTemplate(templateId: number): Promise<void> {
		return this.http.put<void>(`${this.templateUrl}/${templateId}/Status/Archived`, null)
			.toPromise();
	}

	deleteTemplate(templateId: number): Promise<void> {
		return this.http.delete<void>(`${this.templateUrl}/${templateId}`)
			.toPromise();
	}
}
